import people from '@/modules/people-module/people/routes/index.child'
import person from '@/modules/people-module/people/routes/show.child'
import groups from '@/modules/people-module/groups/routes/index.child'
import idCards from '@/modules/people-module/id-cards/routes/index.child'
import personOccupations from '@/modules/people-module/person-occupations/routes/index.child'
import personWorkingPlaces from '@/modules/people-module/person-working-places/routes/index.child'

export default {
  path: '/people',
  redirect: {
    name: 'NotFound',
    params: {
      pathMatch: '/people'
    }
  },
  component: () => import(/* webpackChunkName: "people" */ '../views/PeopleView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  },
  children: [
    people,
    person,
    groups,
    idCards,
    personOccupations,
    personWorkingPlaces
  ]
}
